(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparativa-altitud"] && !Shopify.designMode) return;
  try {
    
(function () {
  var secciones = document.querySelectorAll('.altitud-seccion');
  if (!secciones.length) {
    return;
  }
  if (!('IntersectionObserver' in window)) {
    secciones.forEach(function (seccion) {
      seccion.classList.add('altitud-activo');
    });
    return;
  }
  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('altitud-activo');
          observador.unobserve(entrada.target);
        }
      });
    },
    { threshold: 0.25 }
  );
  secciones.forEach(function (seccion) {
    observador.observe(seccion);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["comparativa-competidores"] && !Shopify.designMode) return;
  try {
    
(function () {
  var secciones = document.querySelectorAll('.compara-seccion');
  secciones.forEach(function (seccion) {
    var tabs = seccion.querySelectorAll('.compara-tab');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = tab.getAttribute('data-tab-index');
        seccion.setAttribute('data-tab-activo', idx);
        tabs.forEach(function (t) {
          var activo = t === tab;
          t.classList.toggle('compara-tab-activo', activo);
          t.setAttribute('aria-selected', String(activo));
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-acordeon"] && !Shopify.designMode) return;
  try {
    
(function () {
  var secciones = document.querySelectorAll('.faq-seccion');
  secciones.forEach(function (seccion) {
    var exclusivo = seccion.getAttribute('data-faq-exclusivo') === 'true';
    var items = seccion.querySelectorAll('.faq-item');
    items.forEach(function (item) {
      var boton = item.querySelector('.faq-pregunta-boton');
      if (!boton) {
        return;
      }
      boton.addEventListener('click', function () {
        var abierto = item.classList.contains('faq-item-activo');
        if (exclusivo && !abierto) {
          items.forEach(function (otro) {
            if (otro !== item) {
              otro.classList.remove('faq-item-activo');
              var otroBoton = otro.querySelector('.faq-pregunta-boton');
              if (otroBoton) {
                otroBoton.setAttribute('aria-expanded', 'false');
              }
            }
          });
        }
        item.classList.toggle('faq-item-activo', !abierto);
        boton.setAttribute('aria-expanded', String(!abierto));
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["origen"] && !Shopify.designMode) return;
  try {
    
(function () {
  function activarTab(root, numero) {
    var tabs = root.querySelectorAll('[data-kv-tab]');
    var paneles = root.querySelectorAll('[data-kv-panel]');
    tabs.forEach(function (tab) {
      if (tab.getAttribute('data-kv-tab') === String(numero)) {
        tab.classList.add('kv-metodos__tab--activo');
        tab.setAttribute('aria-selected', 'true');
      } else {
        tab.classList.remove('kv-metodos__tab--activo');
        tab.setAttribute('aria-selected', 'false');
      }
    });
    paneles.forEach(function (panel) {
      if (panel.getAttribute('data-kv-panel') === String(numero)) {
        panel.classList.add('kv-metodos__panel--activo');
      } else {
        panel.classList.remove('kv-metodos__panel--activo');
      }
    });
  }

  function inicializar(root) {
    if (root.getAttribute('data-kv-init') === 'true') return;
    root.setAttribute('data-kv-init', 'true');

    var tabs = root.querySelectorAll('[data-kv-tab]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activarTab(root, tab.getAttribute('data-kv-tab'));
      });
    });

    root.addEventListener('shopify:block:select', function (evento) {
      var blockId = evento.detail && evento.detail.blockId;
      if (!blockId) return;
      var tabDirecto = root.querySelector('[data-kv-tab][data-block-id="' + blockId + '"]');
      if (tabDirecto) {
        activarTab(root, tabDirecto.getAttribute('data-kv-tab'));
      }
    });

    root.addEventListener('shopify:section:unload', function () {
      root.removeAttribute('data-kv-init');
    });
  }

  function inicializarTodos(contenedor) {
    var raices = (contenedor || document).querySelectorAll('.kv-metodos');
    raices.forEach(function (root) {
      inicializar(root);
    });
  }

  inicializarTodos(document);

  document.addEventListener('shopify:section:load', function (evento) {
    inicializarTodos(evento.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-konverso"] && !Shopify.designMode) return;
  try {
    
(function(){
  var idsRegistrados = [];
  var listenerGlobal = false;

  function feedbackBtn(btn, ok){
    var original = btn.getAttribute('data-label-original') || btn.textContent;
    btn.setAttribute('data-label-original', original);
    btn.textContent = ok ? 'Copiado' : 'Pulsa Ctrl/Cmd+C';
    setTimeout(function(){ btn.textContent = original; }, 1800);
  }

  function copiarId(btn){
    var wrap = btn.closest ? btn.closest('.draco-id-copy-wrap') : null;
    var input = wrap ? wrap.querySelector('[data-draco-id-input]') : null;
    if(!input) return;
    input.removeAttribute('readonly');
    input.focus();
    input.select();
    try{ input.setSelectionRange(0, input.value.length); }catch(e){}
    var copiado = false;
    try{ copiado = document.execCommand('copy'); }catch(e){ copiado = false; }
    input.setAttribute('readonly', 'readonly');
    if(navigator.clipboard && navigator.clipboard.writeText){
      navigator.clipboard.writeText(input.value).then(function(){
        feedbackBtn(btn, true);
      }).catch(function(){
        feedbackBtn(btn, copiado);
      });
    } else {
      feedbackBtn(btn, copiado);
    }
  }

  function registrarScroll(id){
    if(!id) return;
    if(idsRegistrados.indexOf(id) === -1){ idsRegistrados.push(id); }
    if(listenerGlobal) return;
    document.addEventListener('click', function(e){
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if(!a) return;
      var hash = a.hash || '';
      if(!hash) return;
      var objetivo = hash.slice(1);
      if(idsRegistrados.indexOf(objetivo) === -1) return;
      var destino = document.getElementById(objetivo);
      if(!destino) return;
      e.preventDefault();
      destino.scrollIntoView({behavior: 'smooth', block: 'start'});
      if(history.replaceState){ history.replaceState(null, '', hash); }
    });
    listenerGlobal = true;
  }

  function init(root){
    var cont = root.querySelector('.draco-resenas');

    registrarScroll(root.getAttribute('data-draco-id'));

    root.querySelectorAll('[data-draco-copiar]').forEach(function(btn){
      btn.addEventListener('click', function(){
        copiarId(btn);
      });
    });

    if(!cont) return;
    var wrap = root.querySelector('.draco-tarjeta');
    var cards = Array.prototype.slice.call(cont.querySelectorAll('.draco-card'));
    var btn = cont.querySelector('[data-draco-more]');
    var limM = parseInt(wrap.getAttribute('data-limite-movil'),10) || 4;
    var limD = parseInt(wrap.getAttribute('data-limite-escritorio'),10) || 6;
    var paso = parseInt(wrap.getAttribute('data-paso'),10) || 4;
    var limite = window.innerWidth >= 990 ? limD : limM;
    var visibles = limite;

    function render(){
      cards.forEach(function(c,i){
        if(i < visibles){ c.classList.remove('draco-card--oculta'); }
        else { c.classList.add('draco-card--oculta'); }
      });
      if(btn){ btn.style.display = visibles >= cards.length ? 'none' : 'inline-block'; }
    }
    render();

    if(btn){
      btn.addEventListener('click', function(){
        visibles += paso;
        render();
      });
    }

    root.querySelectorAll('[data-draco-scroll]').forEach(function(a){
      a.addEventListener('click', function(e){
        e.preventDefault();
        cont.scrollIntoView({behavior:'smooth', block:'start'});
      });
    });
  }
  document.querySelectorAll('.draco-wrap').forEach(init);
  document.addEventListener('shopify:section:load', function(e){
    var r = e.target.querySelector('.draco-wrap');
    if(r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
